__turbopack_context__.v({
  "closeDrawerButton": "DAD8qq_closeDrawerButton",
  "drawer": "DAD8qq_drawer",
  "drawerHeader": "DAD8qq_drawerHeader",
});
